import { IApplicationConfiguration } from '../interfaces/scheduler_interfaces';
import { ICommand } from 'core-ts-types';
import { LoadProgramTermInfoCommand } from '../views/term_courses/commands/get_program_and_term_info_command';
import { IState } from 'angular-ui-router';
import { FetchStudentActivePlanDetailsCommand } from './commands/fetch_student_active_plan_details_command';
import { GetCourseSearchAuthorizationCommand } from './commands/get_course_search_authorization_command';

export const searchAndAddCourses: IState = {
  url: 'searchandaddcourses/',
  template: '<search-and-add-courses></search-and-add-courses>',
  resolve: {
    authorization: (getCourseSearchAuthorizationCommand: GetCourseSearchAuthorizationCommand) =>
      getCourseSearchAuthorizationCommand(),
    activeTerm: ($stateParams: ng.ui.IStateParamsService, loadProgramTermInfoCommand: LoadProgramTermInfoCommand) =>
      loadProgramTermInfoCommand($stateParams.termId),
    sections: ($stateParams: ng.ui.IStateParamsService, getTermCoursesandScheduledSectionsCommand: ICommand) =>
      getTermCoursesandScheduledSectionsCommand($stateParams.termId),
    studentPlans: (
      fetchStudentActivePlanDetailsCommand: FetchStudentActivePlanDetailsCommand,
      schedulerConfig: IApplicationConfiguration
    ) => fetchStudentActivePlanDetailsCommand()
  }
};



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/search_and_add_courses/state_configuration.ts